// Firebase

/*export const firebaseConfig = {
    apiKey: "AIzaSyCmgy9PO1Ttnye23bkJ6hs2lZrIoKVHaP0",
    authDomain: "anexos-astoreca-testing.firebaseapp.com",
    databaseURL: "https://anexos-astoreca-testing.firebaseio.com",
    projectId: "anexos-astoreca-testing",
    storageBucket: "",
    messagingSenderId: "92591965169"
};*/


//CLONE APP

/*
export const firebaseConfig = {
    apiKey: "AIzaSyA55xF24u2h6_uy98hSmZe0RZVDiRagMRA",
    authDomain: "astoreca-teachers.firebaseapp.com",
    databaseURL: "https://astoreca-teachers.firebaseio.com",
    projectId: "astoreca-teachers",
    storageBucket: "astoreca-teachers.appspot.com",
    messagingSenderId: "798571825999"
};


/*


// PRODUCTION




 export const firebaseConfig = {
	apiKey: "AIzaSyCmgy9PO1Ttnye23bkJ6hs2lZrIoKVHaP0",
     authDomain: "anexos-astoreca-testing.firebaseapp.com",
    databaseURL: "https://anexos-astoreca-testing.firebaseio.com",
    projectId: "anexos-astoreca-testing",
    storageBucket: "anexos-astoreca-testing.appspot.com",
     messagingSenderId: "92591965169"
};


*/

// PRODUCTON V2 

export const firebaseConfig = {
  apiKey: "AIzaSyAXeBYLRNeC9FAVs0EnRi-7kMf5zeSd8b8",
  authDomain: "anexos-astoreca.firebaseapp.com",
  databaseURL: "https://anexos-astoreca.firebaseio.com",
  projectId: "anexos-astoreca",
  storageBucket: "anexos-astoreca.appspot.com",
  messagingSenderId: "179385702981",
  appId: "1:179385702981:web:7a93f6788478a84d0aa12c"
};

//TEST 

/*

export const firebaseConfig = {
    apiKey: "AIzaSyBLWQyfS8bcbCbyaxkRk3Hylpq2vLyiDdc",
    authDomain: "anexos-bd-test.firebaseapp.com",
    databaseURL: "https://anexos-bd-test.firebaseio.com",
    projectId: "anexos-bd-test",
    storageBucket: "anexos-bd-test.appspot.com",
    messagingSenderId: "1055630755842"
};



*/




// WEBPACK FOOTER //
// ./src/config.js